<template>
  <div
    v-if="from!='introDetail'"
    class="pageRightFloat"
    :class="{ getOpacity: getOpacity == true && showGetData == false }"
  >
    <div v-if="pageName !== '跨境电商'" class="getData" @click="getData">
      <img
        src="../../../assets/coursePage/common/pageRightFloat/folder.png"
        alt
      />
      <p>获取</p>
      <p>资料</p>
      <!-- <div class="getDataCode" v-if="showGetData">
        <div class="triangle"></div>
        <img src="../../../assets/coursePage/common/pageRightFloat/getdataQrCode.png" alt />

        <p>
          扫描二维码
          <br />领取资料
        </p>
      </div>-->
    </div>

    <div class="service" @click="zixun('联系客服')">
      <img
        src="../../../assets/coursePage/common/pageRightFloat/service.png"
        alt
      />
    </div>

    <div class="backTop" @click="backTop" v-show="showBackTop">
      <img
        src="../../../assets/coursePage/common/pageRightFloat/backTop.png"
        alt
      />
    </div>

    <div class="pop" v-if="showGetData" @click="showGetData = false">
      <div class="img-box">
        <div class="close" @click="showGetData = false"></div>
        <img
          src="../../../assets/coursePage/common/pageRightFloat/getdataQrCode.png"
          alt
        />
        <p>关注公众号领取资料</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
props:["pageName"],
  data() {
    return {
      minH: 0,
      showBackTop: false,
      showGetData: false,
      getOpacity: false,
      timer: null,
      lastScrollTop: 0,
      from:''
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    this.minH = h;
    this.from=this.getQueryString("from")
    console.log(this.from,'this.from')
  },
  methods: {
  getData(){
    this.showGetData = !this.showGetData
    this.mai(this.pageName,"查看详细大纲",0,null)
  },
    zixun(name) {
      this.mai(this.pageName,"联系客服",0,null)
      this.clickZiXun()
    },
    backTop() {
      this.mai(this.pageName,"回到顶部",0,null)
      // console.log(document.getElementById("app"))
      document.getElementById("block").scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    handleScroll() {
      clearTimeout(this.timer);
      this.$nextTick(() => {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if(!this.lastScrollTop){
          this.lastScrollTop = scrollTop
        }
        let topChange = scrollTop - this.lastScrollTop;
        // 判断是否为竖向滚动
        if (topChange) {
          if (scrollTop >= this.minH / 2) {
            this.showBackTop = true;
          } else {
            this.showBackTop = false;
          }
          this.getOpacity = true;

          this.timer = setTimeout(() => {
            this.getOpacity = false;
            this.lastScrollTop = scrollTop;
          }, 200);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pageRightFloat {
  position: fixed;
  right: 16px;
  bottom: 120px;
  z-index: 110;
  // transition: 1s all;
  .getData {
    position: relative;
    width: 80px;
    height: 160px;
    background: linear-gradient(180deg, #ff5744 0%, #ffa25a 100%);
    box-shadow: 0px 6px 12px -8px rgba(94, 123, 218, 0.12),
      0px 12px 30px 0px rgba(94, 123, 218, 0.16);
    border-radius: 48px;
    text-align: center;
    border: 4px solid #ffffff;

    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    p {
      margin: 0 auto;
      width: 100%;
      text-align: center;
    }
    img {
      margin-top: 32px;
      margin-bottom: 6px;
      width: 32px;
      height: 32px;
    }
    box-sizing: border-box;

    .getDataCode {
      position: absolute;
      top: -50px;
      left: -175px;
      width: 154px;
      height: 204px;
      background: #ffffff;
      box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.06),
        0px 4px 10px 0px rgba(0, 0, 0, 0.08);
      box-sizing: border-box;
      border-radius: 8px;
      z-index: 20;
      .triangle {
        position: absolute;
        top: 80%;
        right: -9px;
        transform: translate(0px, -50%);
        border-style: solid;
        border-color: transparent;
        border-width: 10px 0 10px 10px;
        border-left-color: #fff;
      }

      p {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #1d2129;
        line-height: 20px;
      }
      img {
        margin-top: 15px;
        margin-bottom: 0px;
        width: 134px;
        height: 134px;
      }
    }
  }

  .service {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background: #ffffff linear-gradient(180deg, #2171ef 0%, #71adff 100%);
    box-shadow: 0px 12px 30px 0px rgba(94, 123, 218, 0.1),
      0px 6px 12px -8px rgba(94, 123, 218, 0.16);
    border-radius: 50%;
    border: 4px solid #ffffff;
    text-align: center;
    img {
      width: 32px;
      height: 32px;
    }
    box-sizing: border-box;
  }

  .backTop {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 12px 30px 0px rgba(94, 123, 218, 0.1),
      0px 6px 12px -8px rgba(94, 123, 218, 0.16);
    border-radius: 40px;

    img {
      width: 32px;
      height: 32px;
    }
  }
}

.pop {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  .img-box {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-top: 48px;
    width: 542px;
    height: 638px;
    background: #ffffff;
    border-radius: 16px;
    text-align: center;
    box-sizing: border-box;

    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;

    .close {
      position: absolute;
      left: 50%;
      bottom: -92px;
      transform: translate(-50%, 0px);
      width: 44px;
      height: 44px;
      background: url("../../../assets/coursePage/common/pageRightFloat/close.png")
        no-repeat;
      background-size: cover;
    }

    img {
      margin-bottom: 16px;
      width: 446px;
      height: 446px;
    }
  }
}

.getOpacity {
  opacity: 0.5;
}
</style>
